// extracted by mini-css-extract-plugin
var _1 = "RequestCloseConfirmationModal-modulecheckbox__iQxi_";
var _2 = "RequestCloseConfirmationModal-modulecheckboxLabel__oeaY_";
var _3 = "RequestCloseConfirmationModal-modulecheckboxLabelTitle__EYZPf";
export { _1 as "checkbox", _2 as "checkboxLabel", _3 as "checkboxLabelTitle" }
